import React from "react";

const Step = props => {
  const steps = props.steps;
  const info = props.info;
  var endPrice = 0;

  function onChangeOption(index, e) {
    let options = steps.options;

    options[steps.step] = index;
    if (steps.step === 0) {
      const newOptionIndex = { ...steps, optIndex: index };
      props.setSteps(newOptionIndex);
    } else {
      props.setSteps({ ...steps, options: options });
    }

    if (steps.step !== 0) {
      changePrice(index);
      props.nextStep({ ...steps, price: endPrice });
    } else {
      props.nextStep({ ...steps, options: [index], optIndex: index, price: 0 });
    }
  }

  function changePrice(index) {
    let price = steps.price;

    price += info.optionsPrice[index][steps.optIndex];
    endPrice = price;
  }

  let optionText = {};

  return (
    <div className="stepContent fadeIn" key={steps.step}>
      <div className="mainTitle">{info.title}</div>
      <div className="secTitle">{info.secTitle}</div>

      <div className="stepContainer">
        {info.options.map((option, index) => {
          let path = `/skaiciuokle/img/step${steps.step}${index}.png`;
          return (
            <div
              className={`optionBox ${
                info.options.length === 4 ? "optionBoxSmall" : ""
              }`}
              onClick={onChangeOption.bind(this, index)}
              key={`${steps.step}-${index}`}
            >
              <img
                alt="option"
                className="stepImgStyle"
                style={
                  `${steps.step}${index}` === "00" ? { marginTop: "1rem" } : {}
                }
                src={path}
              />
              <div
                className="optionStep"
                onClick={onChangeOption.bind(this, index)}
                style={
                  steps.options[steps.step] === index
                    ? {
                        ...optionText,
                        color: "white",
                        backgroundColor: "rgb(99,221,105)",
                        borderColor: "white"
                      }
                    : optionText
                }
              >
                <div className="optionStepInner">{option}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Step;
